<template>
  <div
    class="home-container"
    :style="[
      isDesktop
        ? { 'background-image': 'url(' + backgroundFull + ')' }
        : { 'background-image': 'url(' + backgroundMobile + ')' },
    ]"
  >
    <Header></Header>
    <Detail></Detail>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Detail from "../components/Detail.vue";
import backgroundMobile from "@/assets/map_BG-mobile.png";
import backgroundFull from "@/assets/map_BG-Web.png";

export default {
  name: "Home",
  data() {
    return {
      backgroundMobile: backgroundMobile,
      backgroundFull: backgroundFull,
      isDesktop: true
    };
  },
  components: {
    Header,
    Detail,
  },
  mounted() {
    const self = this
    if(window.innerWidth > 375) {
      self.isDesktop = true
    } else {
      self.isDesktop = false
    }
  }
};
</script>

<style scoped>
.home-container {
  max-width: 1200px;
  padding: 15px 50px;
  height: 100%;
  background-color: #222222;
}
@media only screen and (max-width: 600px) { 
  .home-container {
    padding: 5px;
  }
}

</style>
